import Header from "../../Components/Header";
import SideBar from "../../Components/SideBar";
import { BallerzToken, BallerzRedirect } from "../../Client/Ballerz.js";
import { useGetRequest } from "../../Client/index.js";
import SkillCard from "../../Components/SkillCard";
import MobileDropdown from "../../Components/MobileDropdown";
import MobileFooter from "../../Components/MobileFooter";
import { useLocation } from "react-router-dom";
import { useUsername } from "../UsernameContext";
import { Link } from "react-router-dom";
import FriendRequestPanel from "./FriendRequestPanel";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

export default function Skillzone() {
  let ballerzToken = BallerzToken();
  const navigate = useNavigate();

  const location = useLocation();
  const bookingReference = location.state?.bookingReference;

  if (!ballerzToken) {
    BallerzRedirect();
  }

  const endpoint = bookingReference
    ? `skillzone/${bookingReference}`
    : "skillzone";

  const { status, data } = useGetRequest(endpoint, {});

  const { status: statusFriends, data: dataFriends } = useGetRequest(
    "friends/outstanding",
    {}
  );

  const { status: statusFixtures, data: dataFixtures } = useGetRequest(
    "fixtures/list",
    {}
  );

  const { contextUsername, setContextUsername } = useUsername();
  localStorage.setItem("ballerz-display-user", data?.username);

  useEffect(() => {
    if (contextUsername === "redirected") return;

    if (
      status === "fetched" &&
      statusFixtures === "fetched" &&
      data?.sessions?.length === 0 &&
      dataFixtures?.fixtures?.length > 0
    ) {
      setContextUsername("redirected");
      // navigate("/fixtures"); temporarily disable auto-redirect to fixtures page
      navigate("/");
    }
  }, [status, data, dataFixtures, statusFixtures]);

  if (status === "fetched") {
    return (
      <div className="min-h-screen flex flex-col bg-[#070d27] text-white">
        <Header
          title={"skillzone"}
          users={data?.users}
          bookingReference={data?.bookingReference}
          username={data?.username}
        />

        <div className="flex flex-1">
          <SideBar usernames={data?.username} />

          <main className="flex-1 p-4 sm:p-6">
            <Link
              to="/friends/manage"
              className="w-full flex justify-center cursor-pointer"
            >
              <FriendRequestPanel count={dataFriends?.outstanding} />
            </Link>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 items-start">
              <div className="block sm:hidden">
                <MobileDropdown />
              </div>

              {data.sessions?.length === 0 && (
                <a
                  href="https://ballerz.co.uk/book-now/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img
                    src={require("../../Assets/Images/NoSkillzone.png")}
                    alt="No results"
                    draggable={false}
                    className="w-[95%] h-auto mx-auto"
                  />
                </a>
              )}

              {data?.sessions?.map((skill, index) => (
                <SkillCard
                  unit="Points"
                  backgroundImage={skill.ballerzImage}
                  gameImage={skill.ballerzIcon}
                  ballerzGameName={skill.ballerzGameName}
                  esaIsHitMiss={skill.esaIsHitMiss}
                  hit={skill.hit}
                  miss={skill.miss}
                  scoreDisplay={skill.scoreDisplay}
                  best={skill.best}
                  previous={skill.previous ? skill.previous : 0}
                />
              ))}
            </div>

            <div className="block sm:hidden">
              <MobileFooter />
            </div>
          </main>
        </div>
      </div>
    );
  }
}
